<div class="flex">
  <div class="panel-left" #leftElement>
    <div class="notifications-toolbar">
      <div class="btn-group right-btn-group sortable-block">
        <div (click-outside)="mainSort = false"
             [class.open]="mainSort"
             class="dropdown">
          <div class="btn-group pull-left">
            <button (click)="selectSortableType(type);  mainSort = false"
                    *ngFor="let type of sortTypes"
                    [class.active]="type.checked"
                    class="btn btn-sm btn-outline-default"
                    [attr.test-id]="type.title + '-sortButton'"
                    test-id="notifications-sortButton">
              {{ type.title | translate }}
              <em *ngIf="type.checked"
                  [ngClass]="{'fa-sort-up': !type.desc, 'fa-sort-down': type.desc}"
                  class="fa fa-sort-up">
              </em>
            </button>
          </div>
        </div>
      </div>
      <div class="left-btn-group btn-group pull-right">
        <div class="input-group input-group-sm">
          <span class="input-group-addon">
            <em *ngIf="!loading" class="fa fa-light fa-search"></em>
            <em *ngIf="loading" class="fa fa-light fa-spinner fa-spin"></em>
          </span>
          <input type="text"
                 class="form-control search-field"
                 test-id="notifications-searchInput"
                 placeholder="{{ 'NAVBAR.search' | translate }}..."
                 [formControl]="searchInput">
        </div>
      </div>
      <div class="btn-bar-wrapper">
        <div class="row btn-bar btn-bar-sm btn-bar-xs">
          <div class="col-md-1 checkbox text-center">
            <input (click)="clearSelected()"
                   [attr.test-id]="'clearSelectedNotificationsButton'"
                   [checked]="hasSelection()"
                   [disabled]="!selectedNotificationIds?.size"
                   [indeterminate]="selectedNotificationIds?.size && selectedNotificationIds?.size < total"
                   [tooltip]="selectedNotificationIds?.size ? ('NOTIFICATIONS.clear_selection' | translate) : ''"
                   container="body"
                   type="checkbox">
            <i *ngIf="hasSelection()" aria-hidden="true"></i>
          </div>
          <div class="col-md-11 flex">
            <button (click)="readAll()"
                    *ngIf="!hasSelection()"
                    [disabled]="total <= 0 || !hasToRead()"
                    class="btn btn-sm b-light btn-icon-envelope-open-text"
                    test-id="readAllNotificationsButton">
              {{ 'NOTIFICATIONS.read_all' | translate:{count: unreadCount()} }}
            </button>
            <button (click)="unreadAll()"
                    *ngIf="!hasSelection()"
                    [disabled]="total <= 0 || !hasToUnread()"
                    class="btn btn-sm b-light btn-icon-envelope"
                    test-id="unreadAllNotificationsButton">
              {{ 'NOTIFICATIONS.unread_all' | translate:{count: readCount()} }}
            </button>
            <button (click)="readSelected()"
                    *ngIf="hasSelection()"
                    class="btn btn-sm b-light btn-icon-envelope-open-text"
                    test-id="readSelectedNotificationsButton">
              {{ 'NOTIFICATIONS.read_selected' | translate:{selectedCount: selectionCount() || 0} }}
            </button>
            <button (click)="unreadSelected()"
                    *ngIf="hasSelection()"
                    class="btn btn-sm b-light btn-icon-envelope"
                    test-id="unreadSelectedNotificationsButton">
              {{ 'NOTIFICATIONS.unread_selected' | translate:{selectedCount: selectionCount() || 0} }}
            </button>
            <button (click)="downloadSelectedAttachments()"
                    [disabled]="selectedAttachmentCount()<1"
                    class="btn btn-sm b-light align-right btn-icon-download"
                    test-id="downloadSelectedAttachmentsButton">
              {{ 'NOTIFICATIONS.download' | translate:{count: selectedAttachmentCount() || 0} }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div (infiniteReached)="loadMore()"
         *ngIf="notifications.length || loading"
         [enabled]="notifications.length < total"
         class="notifications-list fade-in"
         gp-infinite-scroll>
      <div *ngFor="let notification of notifications"
           [routerLinkActive]="'active'"
           [routerLink]="['/inbox/notifications', notification.id]"
           [class.active]="isRouteActive(notification.id)"
           (click)="updateReadSingleNotification(notification)"
           class="notification text-xs">
        <div (click)="toggle(notification, $event)"
             [attr.test-id]="'selectNotification' + notification.id + 'Button'"
             class="col-md-1 notification-cbx checkbox">
          <input [checked]="isSelected(notification)"
                 readonly
                 type="checkbox"/>
        </div>

        <div class="col-md-8 col-sm-9 col-xs-12 notification-content">
          <div class="notification-dates">
            <div class="flex">
              <div class="left-time-label">
                {{ notification.effectiveDate | gpDate:{timeAgo: true} : (trigger$|async) }}
              </div>
              <div *ngIf="notification.dueDate" class="due-date-label p-l-sm">
                {{ notification.dueDate | gpDate:{timeLeft: true} : (trigger$|async) }}
              </div>
            </div>
            <div *ngIf="notification.sanitizedData.isFallbackRecipient"
                 class="default-recipient" tooltip="{{'INBOX.default_recipient'|translate}}">
              <em class="fa fa-light fa-user-check"></em>
            </div>
          </div>
          <div class="notification-title">
            <span class="not-viewed-notification-indicator" *ngIf="!notification.read"></span>
            {{ notification.notificationHeader }}
            <span *ngIf="notification?.wasProcessed"
                  [ngClass]="notification.sanitizedData.processedClass"
                  class="tag">
               {{ notification.sanitizedData.replyTranslation }}
             </span>
            <i *ngIf=hasAttachment(notification) class="fa fa-light fa-paperclip"></i>
          </div>
          <div class="notification-description text-ellipsis">
            {{ notification.sanitizedData.notificationDescription | gpHtmlToText }}
          </div>
        </div>
      </div>
      <div *ngIf="loading" class="p-x-sm">
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
        <p>
          <skeleton-block width="100%" height="100px" [effect]="'wave'" borderRadius="4"></skeleton-block>
        </p>
      </div>
    </div>

    <gp-illustrated-message *ngIf="!loading && !notifications.length"
                            [text]="'NOTIFICATIONS.no_notifications'"></gp-illustrated-message>
  </div>
  <div gp-resizer
       class="resizer"
       *ngIf="!isSmallDevice() && !loading && notifications?.length"
       [leftElement]="leftElement"
       [rightElement]="rightElement"
       [maxSize]="70"
       [minSize]="30">
  </div>
  <div class="panel-right" #rightElement>
    <router-outlet></router-outlet>
  </div>
</div>
